/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactECharts from "echarts-for-react";
import { getRegionalanalyseResult } from "../../selectors/widget.js";
import Block from "../Block";
import { round } from "lodash";

const Graph = ({ module }) => {
  const { dataset, cityIndex, series } = module;
  const apiResult = useSelector((state) => getRegionalanalyseResult(state, dataset));
  const [mergedOptions, setMergedOptions] = useState(null);

  const [filteredDataset, setFilteredDataset] = useState(null);

  useEffect(() => {
    if (apiResult) {
      let result = JSON.parse(apiResult);
      let filtered = result.response.filter((item) => item.nr === cityIndex && item.aar.length <= 4);

      setFilteredDataset(filtered);
    }
  }, [apiResult]);

  useEffect(() => {
    if (filteredDataset) {
      let data = filteredDataset.sort((a, b) => (a.aar > b.aar ? 1 : -1));

      let seriesData = series.map((item) => {
        let obj = {
          name: item.label,
          type: "bar",
          stack: "total",
          data: data.map((i) => round(i[item.value], 2)),
          label: {
            show: true,
            rotate: -90,
          },
          emphasis: {
            focus: "series",
          },
        };
        return obj;
      });

      let labels = data.map((item) => item.aar);

      let nObj = {
        ...JSON.parse(options),
        tooltip: {
          trigger: "item",
          formatter: "{a}: {c}",
        },
        legend: {},
        xAxis: {
          type: "category",
          data: labels,
        },
        yAxis: {
          type: "value",
        },
        series: seriesData,
      };

      setMergedOptions(nObj);
    }
  }, [filteredDataset]);

  if (!apiResult) return <p>Mangler data fra SSB</p>;
  if (mergedOptions) {
    return (
      <Block>
        <ReactECharts option={mergedOptions} style={{ marginTop: "20px", height: "700px" }} />
      </Block>
    );
  }

  return null;
};
export default Graph;

const options = JSON.stringify({
  grid: { top: 8, right: 10, bottom: 2, left: 40, containLabel: true },
  // xAxis: {
  //   type: 'category',
  //   data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  // },
  yAxis: {
    type: "value",
  },
  // series: [
  //   {
  //     data: [820, 932, 901, 934, 1290, 1330, 1320],
  //     type: 'line',
  //     smooth: true,
  //   },
  // ],
  tooltip: {
    trigger: "item",
    formatter: `{c}%`,
  },
});
